import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { TwilioService } from "@/services/communication/TwilioService";

interface AvailableNumber {
  phoneNumber: string;
  friendlyName?: string;
  locality?: string;
  region?: string;
  phoneType?: 'local' | 'tollFree';
}

export const usePhoneNumberProvisioning = () => {
  const [availableNumbers, setAvailableNumbers] = useState<AvailableNumber[]>([]);
  const [selectedNumber, setSelectedNumber] = useState<string | null>(null);
  const [hasSearched, setHasSearched] = useState(false);

  const searchMutation = useMutation({
    mutationFn: async ({ countryCode, areaCode }: { countryCode: string; areaCode?: string }) => {
      const numbers = await TwilioService.fetchAvailablePhoneNumbers(countryCode, areaCode);
      return numbers;
    },
    onSuccess: (data) => {
      setAvailableNumbers(data);
      setHasSearched(true);
    },
  });

  const clearSearch = () => {
    setAvailableNumbers([]);
    setSelectedNumber(null);
    setHasSearched(false);
  };

  return {
    availableNumbers,
    selectedNumber,
    setSelectedNumber,
    searchNumbers: searchMutation.mutateAsync,
    isSearching: searchMutation.isPending,
    searchError: searchMutation.error,
    clearSearch,
    hasSearched,
  };
};
